import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.024 1.085c.98.071 2.002.549 2.98 1.516.978-.967 1.999-1.444 2.978-1.513 1.106-.079 2.083.368 2.79 1.073 1.39 1.386 1.827 3.895.102 5.62l-.018.017-5.516 4.997a.5.5 0 0 1-.672 0L1.152 7.798l-.018-.017c-1.734-1.734-1.3-4.243.095-5.628.709-.704 1.688-1.148 2.795-1.068",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceFavoriteHeart = { render };
export {
  interfaceFavoriteHeart as default,
  render
};
//# sourceMappingURL=interface-favorite-heart.svg.js.map
